import { IMqq } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export const enum LocalEditCustomEvents {
    /** 客户端触发保存 */
    SaveData = 'localEditSaveData',
    /** 客户端触发图片分享 */
    PictureShare = 'localFileToPictureShare',
    /** 客户端触发播放幻灯片 */
    Presentation = 'presentation',
    /** 客户端获取文档的预占位标题 */
    GetNewLocalFileDefaultName = 'getNewLocalFileDefaultName',
    /** 客户端控制退出编辑态 */
    LocalEditExitEditMode = 'localEditExitEditMode',
}

export interface LocalEditCustomEventsHandlers {
    /** 客户端触发保存 */
    onSaveData: (options: { actionType: string }) => void;
    /** 客户端触发图片分享 */
    onPictureShare: () => void;
    /** 客户端触发演示幻灯片 */
    onPresentation: (options: {
        actionType: string,
        /** 演示结束/退出演示态，调用 jsapi 通知客户端 */
        onFinish: () => void,
    }) => void;
    /** 客户端获取文档的预占位标题 */
    getNewLocalFileDefaultName: () => void;
    /** 客户端主动退出编辑态 */
    exitEditMode: () => void;
}

export class MobileLocalEditAPI {
    public constructor(private mqq: IMqq) {}

    /** 通知移动端本地编辑加载结果 */
    public notifyLoadResult(options: { errorCode: number | string; errorMsg: string }) {
        this.mqq.invoke('docx', 'notifyOpenLocalFileResult', options);
    }

    /** 通知移动端本地编辑保存结果 */
    public notifySaveResult(options: { actionType: string; success: boolean }) {
        this.mqq.invoke('docx', 'localFileSaveResult', options);
    }

    /** 通知客户端关闭上云引导提示 */
    public closeUploadNoticebar() {
        this.mqq.invoke('docx', 'closeNoticeBar4LocalToDrive');
    }

    public sendNewLocalFileDefaultName(newtitle: string) {
        this.mqq.invoke('docx', 'newLocalFileDefaultTitle', { newtitle });
    }

    /** 注册移动端原生按钮交互事件 */
    public registerCustomEvents(handlers: Partial<LocalEditCustomEventsHandlers>) {
        this.mqq.invoke('docx', 'registerCustomEvents', {}, (res: { eventName: string; options: any }) => {
            switch (res?.eventName) {
                case LocalEditCustomEvents.SaveData:
                    handlers?.onSaveData?.({ actionType: res?.options?.actionType ?? '' });
                    break;
                case LocalEditCustomEvents.PictureShare:
                    handlers?.onPictureShare?.();
                    break;
                case LocalEditCustomEvents.Presentation:
                    handlers?.onPresentation?.({
                        actionType: res?.options?.actionType ?? '',
                        onFinish: () => this.onPresentationFinish(),
                    });
                    break;
                case LocalEditCustomEvents.GetNewLocalFileDefaultName:
                    handlers?.getNewLocalFileDefaultName?.();
                    break;
                case LocalEditCustomEvents.LocalEditExitEditMode:
                    handlers?.exitEditMode?.();
            }
        });
    }

    private onPresentationFinish() {
        this.mqq.invoke('docx', 'onPresentationFinish');
    }
}
